module.exports = __webpack_public_path__ + "static/img/h3-1.108bd29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h3-1.png
// module id = jjkO
// module chunks = 1